import { render, staticRenderFns } from "./showStudentGeneralDiary.vue?vue&type=template&id=bb83ab8e&scoped=true"
import script from "./showStudentGeneralDiary.vue?vue&type=script&lang=js"
export * from "./showStudentGeneralDiary.vue?vue&type=script&lang=js"
import style0 from "./showStudentGeneralDiary.vue?vue&type=style&index=0&id=bb83ab8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb83ab8e",
  null
  
)

export default component.exports